module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-5.69658b31.jpg";